import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AccessControl, Button, buttonModes, buttonTypes, Icon, iconNames } from '../../../components'
import { userRightTypes } from '../../../constants'
import { Logger, LoggerTypes } from '../../../utils'
import { ScenarioDialogCreate, ScenarioDialogImport } from '../dialogs'
import ImportExportIcon from '@mui/icons-material/ImportExport'

import './style.scss'

/**
 * @see https://v4.mui.com/components/buttons/#button
 * @returns {div}
 */
export const ScenarioActionsBar = () => {
  const [openDialogCreate, setOpenDialogCreate] = useState(false)
  const [openDialogImport, setOpenDialogImport] = useState(false)
  const { t } = useTranslation()

  const onCreateClick = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioActionsBar.onCreateClick()')
    setOpenDialogCreate(true)
  }
  const onImportClick = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioActionsBar.onImportClick()')
    setOpenDialogImport(true)
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'ScenarioActionsBar.render()')

  return (
    <div className="ScenarioActionsBar">
      <div className="buttonContainer">
        <AccessControl userPermissions={[userRightTypes.SCENARIO_EDIT]} renderNoAccess={() => <></>}>
          <Button
            mode={buttonModes.PRIMARY_ACTION}
            type={buttonTypes.BUTTON}
            text={t('scenarios.head_buttons.create.text')}
            tooltip={t('scenarios.head_buttons.create.tooltip')}
            icon={<Icon name={iconNames.PLUS} size={15} />}
            onClick={onCreateClick}
            className="scenarioCreateButton"
          />
          <Button
            mode={buttonModes.HEADER}
            type={buttonTypes.BUTTON}
            text={t('scenarios.head_buttons.import.text')}
            tooltip={t('scenarios.head_buttons.import.tooltip')}
            icon={<ImportExportIcon />}
            onClick={onImportClick}
          />
        </AccessControl>
      </div>
      {openDialogCreate && <ScenarioDialogCreate openDialog={openDialogCreate} setOpenDialog={setOpenDialogCreate} />}
      {openDialogImport && <ScenarioDialogImport openDialog={openDialogImport} setOpenDialog={setOpenDialogImport} />}
    </div>
  )
}

ScenarioActionsBar.displayName = 'ScenarioActionsBar'
